const toggle = document.querySelector('[data-behaviour="navigation-toggle"]');
import { toggleAttribute } from './utilities.js';

if ( toggle ) {

    toggle.addEventListener('click', (ev) => {
        ev.preventDefault();
        toggleAttribute(document.body, 'data-menu-open');
    });

}

const mobileBack = document.querySelector('[data-behaviour="mobile-menu-back"]');

if ( mobileBack ) {

    mobileBack.addEventListener('click', (ev) => {
        ev.preventDefault();

        toggleAttribute(document.body, 'data-menu-sub');
        const toggle = document.querySelector('[data-behaviour="mobile-menu-toggle"][data-active="true"]');
        
        if(toggle) {
            toggleAttribute(toggle, 'data-active');
        }
        
    });

}

const mobileToggles = document.querySelectorAll('[data-behaviour="mobile-menu-toggle"]');

if (mobileToggles.length > 0) {

    mobileToggles.forEach((toggle) => {

        toggle.addEventListener('click', (ev) => {
            ev.preventDefault();
            
            toggleAttribute(document.body, 'data-menu-sub');
            toggleAttribute(toggle, 'data-active');
            
        });

    });

}

